export default __webpack_public_path__ + "static/media/default.ef9d0df68e2af15d427e9930cf0ad4e4.png";